// CommandsListHelpers – parse command status_info and compute ack percent for UI.

import { CommandAck, CommandDdbItem } from '../../../types/Commands';
import { toMillis, normStatus } from '../../helpers/helpers';

// ---- Helpers ----

export function parseStatusInfo(statusInfo: unknown): CommandAck | null {
    if (!statusInfo) return null;

    let obj: any = statusInfo;

    if (typeof statusInfo === 'string') {
        try {
            obj = JSON.parse(statusInfo);
        } catch {
            return null;
        }
    }

    if (!obj || typeof obj !== 'object') return null;

    const ack = (obj as any).ack && typeof (obj as any).ack === 'object'
        ? (obj as any).ack
        : obj;

    if (!ack || typeof ack !== 'object') return null;

    const result: any = {
        receivedAt: typeof ack.receivedAt === 'number' ? ack.receivedAt : undefined,
        accepted: typeof ack.accepted === 'boolean' ? ack.accepted : undefined,
        state: typeof ack.state === 'string' ? ack.state : undefined,
        reason: typeof ack.reason === 'string' ? ack.reason : undefined,
    };

    if (typeof ack.percent === 'number') {
        result.percent = ack.percent;
    }
    if (typeof ack.bytes === 'number') {
        result.bytes = ack.bytes;
    }
    if (typeof ack.total === 'number') {
        result.total = ack.total;
    }

    return result as CommandAck;
}

export function getAckPercent(ack: CommandAck | null | undefined): number {
    if (!ack) return -1;
    const a: any = ack;

    if (typeof a.percent === 'number') {
        return a.percent;
    }

    if (typeof a.bytes === 'number' && typeof a.total === 'number' && a.total > 0) {
        return Math.round((a.bytes / a.total) * 100);
    }

    return -1;
}

export function isFailedStatus(s?: string): boolean {
    const st = normStatus(s);
    return st === 'FAILED' || st === 'TIMED_OUT' || st === 'CANCELLED';
}

export function isInProgressStatus(s?: string): boolean {
    const st = normStatus(s);
    return st === 'IN_PROGRESS' || st === 'ACKED';
}

/** Extract command timestamp in ms from createdAt/updatedAt fields (ms or epoch seconds). */
export function pickCommandTsMs(cmd?: CommandDdbItem): number | null {
    if (!cmd) return null;
    const cand: Array<unknown> = [
        cmd.createdAt,
        (cmd as unknown as { createdAtS?: number }).createdAtS,
        cmd.updatedAt,
        (cmd as unknown as { updatedAtS?: number }).updatedAtS,
    ];
    for (const v of cand) {
        if (typeof v !== 'number' || !Number.isFinite(v) || v <= 0) continue;
        return toMillis(v);
    }
    return null;
}

